const menu = [
    {
      id: 1,
      title: "Sausage Muffins",
      category: "breakfast",
      price: 5.99,
      img: "./images/item-1.jpg",
      desc: `A pork sausage patty, lightly seasoned with herbs, a free-range egg and a slice of cheese, in a hot, toasted English muffin.  `,
    },
    {
      id: 2,
      title: "Pancakes",
      category: "breakfast",
      price: 3.99,
      img: "./images/item-2.jpg",
      desc: `Every single Sunday begins with pancakes… and ends with leftover pancakes from the morning.  `,
    },
    {
      id: 3,
      title: "crab frittes",
      category: "dinner",
      price: 11.99,
      img: "./images/item-3.jpg",
      desc: `Fold the crabmeat, spring onions, and capsicum into the batter. In a large heavy non-stick frying pan`,
    },
    {
      id: 4,
      title: "Fried eggs",
      category: "breakfast",
      price: 4.99,
      img: "./images/item-4.jpg",
      desc: `It is known for sure that ostrich eggs were fried by fire in ancient Egypt. The Romans used fried eggs as a dessert with honey. `,
    },
    {
      id: 5,
      title: "Lemonade",
      category: "beverages",
      price: 8.99,
      img: "./images/item-5.jpg",
      desc: `Lemonade, the indispensable refresher of summer months `,
    },
    {
      id: 6,
      title: "Hamburger",
      category: "dinner",
      price: 18.99,
      img: "./images/item-6.jpeg",
      desc: `Fletcher Davis of Athens, Texas claimed to have invented the hamburger. According to oral histories,`,
    },
    {
      id: 7,
      title: "Sandwiches",
      category: "breakfast",
      price: 8.99,
      img: "./images/item-7.png",
      desc: `Most of us have heard of the fourth Earl of Sandwich, otherwise known as John Montagu.`,
    },
    {
      id: 8,
      title: "Lamb chops",
      category: "dinner",
      price: 21.99,
      img: "./images/item-8.jpg",
      desc: `The word lamb comes from the German lambiz. As early as 10,000 years ago in Central Asia, man discovered that   `,
    },
    {
      id: 9,
      title: "Cocktail",
      category: "beverages",
      price: 13.99,
      img: "./images/item-9.jpg",
      desc: ` Our cocktails are different from each other and with their flavors to your full taste.`,
    },
    {
        id: 10,
        title: "Pizza",
        category: "dinner",
        price: 13.99,
        img: "./images/item-10.jpg",
        desc: `The first Italian pizza restaurant, Antica Pizzeria Port'Alba, began baking pizzas in 1738 as the dish`,
      },
      {
        id: 11,
        title: "mango sunset",
        category: "beverages",
        price: 13.99,
        img: "./images/item-11.jpg",
        desc: `The original tree was grown from a seed planted in the grove of Frank Adams in Pine Island, Florida.`,
      },
      {
        id: 12,
        title: "kiwi margarita",
        category: "beverages",
        price: 10.99,
        img: "./images/item-12.png",
        desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
      },
  ];
  export default menu;
  